<form [formGroup]="form" class="container-fluid w-100 p-2 p-md-3 p-lg-4 advanced-search-bar" style="padding-bottom: 10px !important;">
  <div class="d-flex row ml-1 mr-1">

    <!--    selezione filtro-->
    <div class="col-12 col-md-4">
      <div class="select-side no-label">
        <i class="fas fa-caret-down"></i>
      </div>
      <select class="selectpicker"
              id="filters"
              data-live-search="true"
              data-size="8"
              width="fit"
              [attr.data-none-results-text]="'no-selection' | translate"
              [attr.data-none-results-text]="'PAGE.CLIENT_ACCOUNT_CHOICE.FORMS.NO_RESULTS' | translate"
              [attr.title]="'select-option' | translate"
              [formControl]="form.get('filter')"
              [formControlName]="'filter'"
              (ngModelChange)="onFilterSelected($event)"
      >
        <ng-container *ngFor="let f of filters">
          <option [value]="f.id">{{'' + f.label | translate}}</option>
        </ng-container>
      </select>
    </div>


    <div class="col-12 col-md-4 mt-1 mt-md-0">
      <!--    filtro text-input-->
      <ng-container *ngIf="selectedFilter?.type ==='text'">
        <input type="{{selectedFilter.subtype ? selectedFilter.subtype: 'text'}}" class="form-control"
               pattern="{{selectedFilter?.pattern ? selectedFilter.pattern:''}}"
               id="{{selectedFilter?.dtoField+'text'}}"
               [formControl]="form.get('input')"
               [ngClass]="{'is-invalid': !form.get('input').valid && form.get('input').dirty}"/>
        <app-error-label [control]="form.get('input')" [errors]="formErrors.input"></app-error-label>
      </ng-container>

      <!--    PORCATA di filtro double input SOLO per ricerca certificati SOLO-->
      <ng-container *ngIf="selectedFilter?.type ==='select-text'">
        <div class="row">
          <div class="col-4">
            <div class="select-side no-label">
              <i class="fas fa-caret-down"></i>
            </div>
            <select id="{{selectedFilter?.dtoField+'select-text1'}}"
                    class="selectpicker show-tick form-control"
                    [formControl]="form?.get('input1')"
                    [attr.title]="'select-option' | translate"
                    [ngClass]="{'is-invalid': !form?.get('input1')?.valid && form?.get('input1')?.dirty}">
              <ng-container *ngFor="let option of selectedFilter?.options">
                <option [value]="option.value">{{'' + option.label | translate}}</option>
              </ng-container>
            </select>
          </div>
          <div class="col"><input type="{{selectedFilter.subtype ? selectedFilter.subtype: 'text'}}"
                                  class="form-control"
                                  pattern="{{selectedFilter?.pattern && form?.get('input1').value ==='IT' ? selectedFilter.pattern:''}}"
                                  id="{{selectedFilter?.dtoField+'select-text2'}}"
                                  [attr.placeholder]="'ENTER_FIRST_CHARS_PLACEHOLDER'|translate"
                                  [formControl]="form?.get('input2')"
                                  [ngClass]="{'is-invalid': !form?.get('input2')?.valid && form?.get('input2')?.dirty}"/>
            <app-error-label [control]="form?.get('input2')" [errors]="formErrors?.input2"></app-error-label>
          </div>
        </div>
      </ng-container>

      <!--    filtro date-->
      <ng-container *ngIf="selectedFilter?.type ==='date'">
        <div class="input-group">
          <input class="form-control" placeholder="gg/mm/aaa" angular-mydatepicker
                 [formControl]="form.get('input')" [options]="datePickerOptions" #dp="angular-mydatepicker"
                 [locale]="translate.currentLang"
                 [ngClass]="{'is-invalid': !form.get('input').valid && form.get('input').dirty}"/>
          <div class="input-group-append" *ngIf="form.get('input').value">
            <button type="button" class="btn btn-primary btn-calendar" (click)="dp.clearDate()">
              <i class="far fa-window-close"></i>
            </button>
          </div>
          <div class="input-group-append">
            <button type="button" class="btn btn-primary btn-calendar" (click)="dp.toggleCalendar()">
              <i class="far fa-calendar-alt"></i>
            </button>
          </div>
        </div>
        <app-error-label [control]="form.get('input')" [errors]="formErrors.input"></app-error-label>
      </ng-container>

      <!--    filtro boolean-->
      <ng-container *ngIf="selectedFilter?.type ==='boolean'">
        <div class="form-check">
          <div class="toggles">
            <label for="{{selectedFilter?.dtoField+'boolean'}}">
              {{'BUTTON.HIDE_SHOW' | translate}}
              <input type="checkbox" id="{{selectedFilter?.dtoField+'boolean'}}"
                     [formControl]="form.get('input')"
                     [checked]="form.get('input').value === true"
                     [ngClass]="{'is-invalid': !form.get('input').valid && form.get('input').dirty}">
              <span class="lever"></span>
            </label>
          </div>
        </div>
        <app-error-label [control]="form.get('input')" [errors]="formErrors.input"></app-error-label>
      </ng-container>

      <!--    filtro select-->
      <ng-container *ngIf="selectedFilter?.type ==='select'">
        <div class="col">
          <div class="select-side no-label">
            <i class="fas fa-caret-down"></i>
          </div>
          <select id="{{selectedFilter?.dtoField+'select'}}"
                  class="selectpicker show-tick form-control"
                  [formControl]="form.get('input')"
                  [attr.title]="'select-option' | translate"
                  [ngClass]="{'is-invalid': !form.get('input').valid && form.get('input').dirty}">
            <ng-container *ngFor="let option of selectedFilter?.options">
              <option [value]="option.value">{{(option.label | translate) || option.label}}</option>
            </ng-container>
          </select>
        </div>
      </ng-container>

      <!--    filtro multi-select-->
      <ng-container *ngIf="selectedFilter?.type ==='multi-select'">
        <div class="col">
          <div class="select-side no-label">
            <i class="fas fa-caret-down"></i>
          </div>
          <select id="{{selectedFilter?.dtoField+'multi-select'}}"
                  multiple
                  data-multiple-separator="-"
                  class="selectpicker show-tick form-control"
                  [formControl]="form.get('input')"
                  [attr.title]="'select-option' | translate"
                  [ngClass]="{'is-invalid': !form.get('input').valid && form.get('input').dirty}">
            <ng-container *ngFor="let option of selectedFilter?.options">
              <option [value]="option.value">{{(option.label | translate) || option.label}}</option>
            </ng-container>
          </select>
        </div>
      </ng-container>
    </div>

    <div class="col-12 col-md-4 mt-1 mt-md-0">
        <div class="row">
        <button class="btn btn-primary pl-5 pr-5" style="margin-right: auto;" (click)="onSearch()" [disabled]="form.invalid || form.pending">
          <span class="d-none d-lg-block">{{'BUTTON.SEARCH' | translate}}</span>
          <i class="fas fa-search d-lg-none"></i>
        </button>

        <button class="btn btn-primary" (click)="onDownload()" 
          id="button_csv"
          data-toggle="popover"
          data-trigger="hover"> 
          <span class="d-none d-lg-block">{{'DOWNLOAD_CSV' | translate}}</span>
          <i class="fas fa-info d-lg-none"></i>
        </button>
      </div>
    </div>

    <div class="d-none">
      <div class="popover-body-info-download-csv">
        {{'CSV_MAX_LENGTH' | translate}} 
      </div>
    </div>

  </div>
  <div *ngIf="activeFilters?.length > 0" class="row p-3">
    <div *ngFor="let f of activeFilters" class="col-auto">
      <div class="chip">
        <span *ngIf="f.type === 'date'" class="chip-label">{{f.label | translate}}: {{f.value.singleDate.formatted |translate}}</span>
        <span *ngIf="f.type !== 'multi-select' && f.type !== 'date'" class="chip-label">{{f.label | translate}}: {{f.value |translate}}</span>
        <span *ngIf="f.type === 'multi-select'" class="chip-label">
          {{f.label | translate}}:
          <ng-container *ngFor="let item of f.value; let l = last">
            {{item | translate}}<span *ngIf="!l">,</span>
          </ng-container>
        </span>

        <button (click)="deleteFilter(f)">
          <svg class="icon">
            <use xlink:href="assets/svg/sprite.svg#it-close"></use>
          </svg>
          <span class="sr-only">{{'BUTTON.DELETE_FILTER' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</form>

